// Ensure the script only runs once, even if it's included multiple times
if (!window.trypticScriptLoaded) {
    window.trypticScriptLoaded = true; // Set the flag so the script doesn't run again

  // Get all elements with the class 'tryptic__block'
  var trypticBlocks = document.querySelectorAll('.tryptic__block');
  
  // Add click event listener to each tryptic block
  trypticBlocks.forEach(function(block) {
      // Add click event listener to the tryptic block
      block.addEventListener('click', function(event) {
          // Find the anchor element within the tryptic block
          var anchor = block.querySelector('.tryptic__block-text-container a');
  
          // Check if an anchor element exists within the tryptic block
          if (anchor) {
              // Prevent the default action of the click event
              event.preventDefault();
  
              // Get the URL from the anchor element
              var url = anchor.getAttribute('href');
  
              // Navigate to the URL
              window.location.href = url;
          }
      });
  });
  
  // DYNAMIC TEXT BLOCK
  document.addEventListener('DOMContentLoaded', function () {
      const flipContainers = document.querySelectorAll('.dynamic-message-container'); // Select all instances
  
      flipContainers.forEach(function(flipContainer) {
          console.log(flipContainer); // Ensure the correct element is selected
      });
  
      flipContainers.forEach(function(flipContainer) {
          const front = flipContainer.querySelector('.front');
          const back = flipContainer.querySelector('.back');
  
          // Collect the dynamic message parts and their colors from the data attributes, only if they are not empty
          const messages = [
              { text: flipContainer.getAttribute('data-message-part-1'), color: flipContainer.getAttribute('data-part-1-color') },
              { text: flipContainer.getAttribute('data-message-part-2'), color: flipContainer.getAttribute('data-part-2-color') },
              { text: flipContainer.getAttribute('data-message-part-3'), color: flipContainer.getAttribute('data-part-3-color') },
              { text: flipContainer.getAttribute('data-message-part-4'), color: flipContainer.getAttribute('data-part-4-color') },
              { text: flipContainer.getAttribute('data-message-part-5'), color: flipContainer.getAttribute('data-part-5-color') }
          ].filter(message => message.text && message.text.trim() !== ''); // Filter out any blank or empty strings
  
          // If no valid messages, stop further execution for this container
          if (messages.length === 0) return;
  
          let currentIndex = 0;
  
          // Function to flip the card and update content
          function flipCard() {
              // Update index first before flipping to the next message
              currentIndex = (currentIndex + 1) % messages.length;
  
              //console.log('Before flip:', flipContainer.classList.contains('flip')); // Check if 'flip' is applied before
                          
              // Toggle flip class
              flipContainer.classList.toggle('flip');

              //console.log('After flip:', flipContainer.classList.contains('flip')); // Check if 'flip' is applied after
  
              // Update content based on the flip state
              if (flipContainer.classList.contains('flip')) {
                  // Back is coming into view, so update its content
                  back.textContent = messages[currentIndex].text;
                  back.style.color = messages[currentIndex].color; // Update color for back
              } else {
                  // Front is coming into view, so update its content
                  front.textContent = messages[currentIndex].text;
                  front.style.color = messages[currentIndex].color; // Update color for front
              }
          }
        
          // Set an interval to flip every 3 seconds
          setInterval(flipCard, 3000);
      });
  });
  
  
  
  document.querySelectorAll('.tryptic__block').forEach(block => {
    // Apply hover effects on desktop (mouse events)
    block.addEventListener('mouseenter', function() {
      applyFilters(block);
      toggleTrypticImageEffect(block, true); // Simulate hover effect for ::after
    });
    
    block.addEventListener('mouseleave', function() {
      resetFilters(block);
      toggleTrypticImageEffect(block, false); // Remove hover effect for ::after
    });
  
    // Apply touch support for mobile devices
    block.addEventListener('touchstart', function() {
      applyFilters(block);
      toggleTrypticImageEffect(block, true); // Simulate hover effect for ::after
    });
  
    block.addEventListener('touchend', function() {
      resetFilters(block);
      toggleTrypticImageEffect(block, false); // Remove hover effect for ::after
    });
  });
  
  // Function to apply filters
  function applyFilters(block) {
    const draggableImage = block.querySelector('.draggable-element');
    const draggableText = block.querySelector('.draggable-text');
    
    // Handle image filter
    if (draggableImage) {
      const originalFilter = getComputedStyle(draggableImage).filter;
      draggableImage.setAttribute('data-original-filter', originalFilter);
      /* kill this line below to remove the additional filtering*/
      /* draggableImage.style.filter = `${originalFilter} saturate(50%) brightness(80%)`;*/
    }
  
    // Handle text filter
    if (draggableText) {
      const originalFilter = getComputedStyle(draggableText).filter;
      draggableText.setAttribute('data-original-filter', originalFilter);
      /* kill this line below to remove the additional filtering*/
      /*draggableText.style.filter = `${originalFilter} saturate(50%) brightness(80%)`;*/
    }
  }
  
  // Function to reset filters
  function resetFilters(block) {
    const draggableImage = block.querySelector('.draggable-element');
    const draggableText = block.querySelector('.draggable-text');
  
    // Reset image filter
    if (draggableImage) {
      const originalFilter = draggableImage.getAttribute('data-original-filter');
      draggableImage.style.filter = originalFilter ? originalFilter : 'none';
    }
  
    // Reset text filter
    if (draggableText) {
      const originalFilter = draggableText.getAttribute('data-original-filter');
      draggableText.style.filter = originalFilter ? originalFilter : 'none';
    }
  }
  
  // Function to toggle tryptic__block-image hover effect
  function toggleTrypticImageEffect(block, isActive) {
    const trypticImage = block.querySelector('.tryptic__block-image');
    
    if (trypticImage) {
      if (isActive) {
        trypticImage.classList.add('hovered'); // Add hover class
      } else {
        trypticImage.classList.remove('hovered'); // Remove hover class
      }
    }
  }

}


/* BACKGROUND IMAGE ROTATION */
document.addEventListener("DOMContentLoaded", function () {
  const rotationInterval = 5000;
  const transitionDuration = 500;

  // Track previous viewport width to detect viewport changes
  let previousViewport = window.innerWidth;
  
  // Helper function to reset image states
  function resetImageStates(rotatingContainer) {
      const rotatingImages = rotatingContainer.querySelectorAll(".rotating-image");
      rotatingImages.forEach(image => {
          image.classList.remove("slide-in", "slide-out", "active");
          // Remove the inline opacity to let CSS control it
          image.style.opacity = '';
      });
      if (rotatingImages.length > 0) rotatingImages[0].classList.add("active");
  }

  // Function to handle image rotation
  function rotateImages(rotatingContainer) {
      const rotatingImages = rotatingContainer.querySelectorAll(".rotating-image");
      let currentIndex = 0;

      function rotate() {
          const currentImage = rotatingImages[currentIndex];
          const nextIndex = (currentIndex + 1) % rotatingImages.length;
          const nextImage = rotatingImages[nextIndex];

          nextImage.classList.add("slide-in");
          currentImage.classList.add("slide-out");

          currentImage.addEventListener("transitionend", () => {
              currentImage.classList.remove("active", "slide-out");
              nextImage.classList.add("active");
              nextImage.classList.remove("slide-in");
              currentIndex = nextIndex;
          }, { once: true });
      }

      // Initial setup and interval for rotation
      resetImageStates(rotatingContainer);
      setInterval(rotate, rotationInterval + transitionDuration);
  }

  // Initialize rotations for each container
  const rotatingContainers = document.querySelectorAll(".rotating-container.desktop-only, .rotating-container.mobile-only, .rotating-container.both");
  rotatingContainers.forEach(container => rotateImages(container));

  // Detect viewport change to reset rotation states
  window.addEventListener("resize", () => {
      const currentViewport = window.innerWidth;

      // Only reset if the viewport size group changes (between desktop and mobile)
      if ((previousViewport >= 768 && currentViewport < 768) || (previousViewport < 768 && currentViewport >= 768)) {
          rotatingContainers.forEach(container => resetImageStates(container));
      }
      previousViewport = currentViewport;
  });
});



/*document.addEventListener('DOMContentLoaded', function () {
  var draggableImage = document.querySelector('.draggable-image');

  if (draggableImage) {
    draggableImage.addEventListener('mousedown', function (e) {
      var offsetX = e.clientX - draggableImage.offsetLeft;
      var offsetY = e.clientY - draggableImage.offsetTop;

      function moveAt(e) {
        var newTop = e.clientY - offsetY;
        var newLeft = e.clientX - offsetX;

        // Update style dynamically to simulate dragging
        draggableImage.style.top = `${newTop}px`;
        draggableImage.style.left = `${newLeft}px`;
      }

      document.addEventListener('mousemove', moveAt);

      draggableImage.onmouseup = function () {
        document.removeEventListener('mousemove', moveAt);
        draggableImage.onmouseup = null;
      };
    });
  }
});*/


/* BEGIN "CTWYR" REPOSITIONING AFTER BLOCK 2 */
/*
document.addEventListener("DOMContentLoaded", function () {
  function findSectionByText(text) {
    // Get all <section> elements
    const sections = document.querySelectorAll("section");

    // Loop through sections and check if any contains the target text
    for (const section of sections) {
      if (section.textContent.includes(text)) {
        return section;
      }
    }
    return null;
  }

  const trypticContainer = document.querySelector(".tryptic");
  const firstTrypticBlock = trypticContainer?.querySelector(".tryptic__block");
  const chooseTheWaySection = findSectionByText("Choose The Way You Ride"); // Find section dynamically

  if (!firstTrypticBlock || !chooseTheWaySection) return;

  // Store the original ID (if it exists)
  const originalId = chooseTheWaySection.getAttribute("id");

  // Clone the section for mobile use
  const mobileVersion = chooseTheWaySection.cloneNode(true);
  
  // Remove the ID from the cloned version
  if (originalId) {
    mobileVersion.removeAttribute("id");
  }

  // Add classes to control visibility
  mobileVersion.classList.add("mobile-only"); // Cloned version for mobile
  chooseTheWaySection.classList.add("desktop-only"); // Original version for desktop

  // Insert mobile version after the first tryptic block
  firstTrypticBlock.insertAdjacentElement("afterend", mobileVersion);
});
*/
/* //END "CTWYR" REPOSITIONING AFTER BLOCK 2 */


/* WORKING -- BUT REQUIRES SPECIFIC TARGETING OF EXACT ID
  document.addEventListener("DOMContentLoaded", function () {
  let originalParent = null; // Stores original parent section
  let fullWidthRow = null; // Stores reference to created full-width div

  function moveSectionOnMobile() {
    const trypticContainer = document.querySelector(".tryptic");
    const trypticParentSection = trypticContainer?.closest("section"); // Finds the parent <section> of tryptic
    const firstTrypticBlock = trypticContainer?.querySelector(".tryptic__block");
    const chooseTheWaySection = document.getElementById("shopify-section-template--16979966525518__section_image_block_carousel_8VcrUN");

    if (!firstTrypticBlock || !chooseTheWaySection || !trypticParentSection) return;

    if (window.innerWidth <= 768) {
      // Store the original parent section only once
      if (!originalParent) {
        originalParent = trypticParentSection;
      }

      // Prevent duplicate .full-width-mobile divs
      if (!fullWidthRow) {
        fullWidthRow = document.createElement("div");
        fullWidthRow.classList.add("full-width-mobile");
        fullWidthRow.appendChild(chooseTheWaySection);
        firstTrypticBlock.insertAdjacentElement("afterend", fullWidthRow);
      }
    } else {
      // Restore to original position: Move after the parent <section> of .tryptic
      if (originalParent && originalParent.nextElementSibling !== chooseTheWaySection) {
        originalParent.insertAdjacentElement("afterend", chooseTheWaySection);
      }

      // Remove the full-width div if it exists
      if (fullWidthRow) {
        fullWidthRow.remove();
        fullWidthRow = null; // Reset reference
      }
    }
  }

  moveSectionOnMobile(); // Run on page load
  window.addEventListener("resize", moveSectionOnMobile); // Run on window resize
});
*/
